/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_JSXRuntime as JSXRuntime,
  rec_Mt as Mt,
  rec_React as React,
  rec_RutaConPermiso as RutaConPermiso,
  rec_paginasPorRuta as paginasPorRuta,
} from "../../runtime/index.jsx";
export function ConstruirRuta(e) {
  let { path: t, puede: n } = e;
  return (
    <Mt
      key={t}
      path={t}
      element={<RutaConPermiso puede={n} Componente={paginasPorRuta[t]} />}
    />
  );
}
